import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { LARGE_MARGIN, MIDDLE_MARGIN } from '../../../../theme';
import { border } from '../CategoryPage/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    errorWrapper: {
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    headerWrapper: {
      [theme.breakpoints.up('md')]: {
        marginBottom: LARGE_MARGIN,
        '& $headerContentWrapper': {
          paddingBottom: 0,
        },
      },
    },
    headerContentWrapper: {},
    headerInfoContainer: {
      display: 'none',
      ...border,
      [theme.breakpoints.up('md')]: {
        display: 'block',
        paddingTop: LARGE_MARGIN,
        paddingBottom: MIDDLE_MARGIN,
        position: 'relative',
      },
    },
    expertInfoContainer: {
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    imageWrapper: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'block',
      },
    },
  }),
);

export default useStyles;
